import { render, staticRenderFns } from "./main.cotizaciones.vue?vue&type=template&id=2dbe44a7"
import script from "./main.cotizaciones.vue?vue&type=script&lang=js"
export * from "./main.cotizaciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports